import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home';
import User from '@/views/User';
import Author from '@/views/Author';
import Dashboard from '@/views/Dashboard';
import Publications from '@/views/Publications';
import OAPublications from '@/views/OAPublications';
import Subscription from '@/views/Subscription';
import Licenses from '@/views/Licenses';
import Login from '@/views/Login';
import licensesStatus from '@/views/licensesStatus';
import userGroup from '@/views/UserGroup';
import organization from '@/views/Organization';
import collection from '@/views/Collection';
import userCollection from '@/views/UserCollection';
import groupSubscription from '@/views/GroupSubscription';
import groupSubscriptionDetails from '@/views/GroupSubscriptionDetails';
import passphraseHint from '@/views/PassphraseHint';
import ImportOnixPublications from '@/views/Import/ImportOnixPublications';
import UserActionLogs from '@/views/UserActionLogs';
import UserRequest from '@/views/UserRequest';
import PurchasePublication from '@/views/Purchase'
import Lending from '@/views/Lending'
import PurchaseOrderCancel from '@/views/PurchaseOrderCancel'
import ExternalLinks from '@/views/ExternalLinks'
import Journal from '@/views/Journal'
import JournalCollection from '@/views/JournalCollection'

import OrgDashboard from '@/views/Organization/OrgDashboard';
import OrgUsers from '@/views/Organization/OrgUsers';
import OrgMyCollections from '@/views/Organization/OrgMyCollections'
import OrgGroups from '@/views/Organization/OrgGroups'
import OrgPublications from '@/views/Organization/OrgPublications'
import OrgMyPublications from '@/views/Organization/OrgMyPublications'
import OrgGroupSubscription from '@/views/Organization/OrgGroupSubscription'
import OrgCollections from '@/views/Organization/OrgCollections'
import OrgLicenses from '@/views/Organization/OrgLicenses'
import OrgUserSubscription from '@/views/Organization/OrgUserSubscription'
import OrgLogs from '@/views/Organization/OrgLogs'
import OrgViewMyPublications from "@/views/Organization/OrgViewMyPublications"
import OrgBulkUsers from '@/views/Organization/OrgBulkUsers'
import OrgCollectionDetails from '@/views/Organization/OrgCollectionDetails'
import OrgJournalCollection from '@/views/Organization/OrgJournalCollection'
import OrgViewMyJournals from '@/views/Organization/OrgViewMyJournals'



import PubDashboard from '@/views/Publisher/PubDashboard'
import PubPublications from '@/views/Publisher/PubPublications'
import Purchase from '@/views/Purchase'
import FulfillmentCollections from '@/views/FulfillmentCollections'
import FulfillmentDetails from '@/views/FulfillmentCollectionDetail'
import OrgCollectionNew from '@/views/Organization/OrgCollectionNew'
import OrgUserGroups from '@/views/Organization/OrgUserGroups'
import OrgOrganizationGroups from '@/views/Organization/OrgOrganizationGroups'
import OrgCollectionGroup from '@/views/Organization/OrgCollectionGroup/'

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'dashboard', component: Dashboard, },
  { path: '/dashboard', name: 'dashboard', component: Dashboard, },
  { path: '/user', name: 'users', component: User, },
  { path: '/author', name: 'author', component: Author, },
  { path: '/publications', name: 'publications', component: Publications, },
  { path: '/oaPublications', name: 'oaPublications', component: OAPublications, },
  { path: '/Subscription', name: 'subscription', component: Subscription, },
  { path: '/licenses', name: 'licenses', component: Licenses, },
  { path: '/login', name: 'login', component: Login, },
  { path: '/licensesStatus/:id', name: 'licensesStatus', component: licensesStatus, },
  { path: '/licensesStatus/license/:id', name: 'licensesStatus', component: licensesStatus, },
  { path: '/usergroup', name: 'UserGroup', component: userGroup, },
  { path: '/organization', name: 'Organization', component: organization, },
  { path: '/collection', name: 'Collection', component: collection, },
  { path: '/journal-collection', name: 'JournalCollection', component: JournalCollection, },
  { path: '/userCollection', name: 'UserCollection', component: userCollection, },
  { path: '/groupSubscription', name: 'GroupSubscription', component: groupSubscription, },
  { path: '/groupSubscriptionDetails/:id', name: 'GroupSubscriptionDetails', component: groupSubscriptionDetails, },
  { path: '/passphraseHint', name: 'PassphraseHint', component: passphraseHint, },
  { path: '/import', name: 'import', component: ImportOnixPublications, },
  { path: '/userlogs', name: 'UserActionLogs', component:   UserActionLogs , },
  { path: '/user-request', name: 'UserRequest', component:   UserRequest , },
  { path: '/orgpurchasepublication', name: 'PurchasePublication', component: PurchasePublication, },
  { path: '/lending', name: 'Lending', component: Lending, },
  { path: '/purchaseOrderCancel/:id/:organizationId/:isCollection', name: 'PurchaseOrderCancel', component: PurchaseOrderCancel, },
  { path: '/ExternalLinks', name: 'ExternalLinks', component:   ExternalLinks , },
  { path: '/Journal', name: 'ExternalLiJournalnks', component:   Journal , },
  
  { path: '/organization/dashboard', name: 'Dashboard', component: OrgDashboard, },
  { path: '/organization/users', name: 'Users', component: OrgUsers, },
  { path: '/organization/mycollection', name: 'OrgMyCollections', component: OrgMyCollections, },
  { path: '/organization/myjournals', name: 'OrgViewMyJournals', component: OrgViewMyJournals, },
  { path: '/organization/groups', name: 'Groups', component: OrgGroups, },
  { path: '/organization/publications', name: 'Publications', component: OrgPublications, },
  { path: '/organization/mypublications', name: 'MyPublications', component: OrgMyPublications, },
  { path: '/organization/groupSubscription', name: 'OrgGroupSubscription', component: OrgGroupSubscription, },
  { path: '/organization/collections', name: 'OrgCollections', component: OrgCollections, },
  { path: '/organization/licenses', name: 'OrgLicenses', component: OrgLicenses, },
  { path: '/organization/user-subscription', name: 'OrgUserSubscription', component: OrgUserSubscription, },
  { path: '/organization/logs', name: 'Logs', component: OrgLogs, },
  { path: '/organization/OrgViewMyPublications', name: 'OrgViewMyPublications', component: OrgViewMyPublications, },
  { path: '/organization/bulk_users', name:'BulkUsers', component: OrgBulkUsers},
  { path: '/publisher/dashboard', name: 'Dashboard', component: PubDashboard, },
  { path: '/publisher/publications', name: 'Publications', component: PubPublications, },

  { path: '/fulfillmentcollections', name: 'FulfillmentCollections', component: FulfillmentCollections, },
  { path: '/fulfillmentDetails/:id/:collection', name: 'FulfillmentDetails', component: FulfillmentDetails},
  { path: '/purchase', name: 'Purchase', component: Purchase, },
  { path: '/organization/OrgCollectionNew', name:'OrgCollectionNew', component :OrgCollectionNew },
  { path: '/organization/OrgUserGroups' , name: 'OrgUserGroups', component : OrgUserGroups},
  { path: '/organization/OrgOrganizationGroups', name: 'OrgOrganizationGroups', component : OrgOrganizationGroups},
  { path: '/organization/OrgCollectionGroup', name: 'OrgCollectionGroup', component : OrgCollectionGroup},
  { path: '/organization/CollectionDetail/:id', name: 'OrgCollectionDetail', component: OrgCollectionDetails},
  { path: '/organization/OrgJournalCollection', name: 'OrgJournalCollection', component : OrgJournalCollection},


];

//localStorage.getItem("token");
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  var token = localStorage.getItem("token");
  console.log('to.name ' + to.name)

  if ((to.name !== 'login' && (to.name == 'licensesStatus' || to.name == 'passphraseHint')) && token == null) {
    if (to.name == 'licensesStatus' || to.name == 'passphraseHint')
      next();
    else
      next({ name: 'login' });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js